const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.startOutputBuffer();
                this.echo(`  `);
                this.echo(this.include(context, this.source, this.loadTemplate(`e178874c0cbc692ff8b5e6a19f6b054ef16947389e7d8d7f609b24a507f67777`, `e178874c0cbc692ff8b5e6a19f6b054ef16947389e7d8d7f609b24a507f67777`, 2, 15), undefined, true, false, 2));
                context.proxy[`_heading`] = (() => {let tmp = this.getAndCleanOutputBuffer(); return tmp === '' ? '' : new this.Markup(tmp, this.env.getCharset());})();
                this.echo(`
`);
                this.echo(this.include(context, this.source, this.loadTemplate(`e178874c0cbc692ff8b5e6a19f6b054ef16947389e7d8d7f609b24a507f67777`, `e178874c0cbc692ff8b5e6a19f6b054ef16947389e7d8d7f609b24a507f67777`, 12, 16), new Map([[`class`, `o-container--prose`], [`_heading`, (context.has(`_heading`) ? context.get(`_heading`) : null)]]), false, false, 12));
            }

            getTemplateName() {
                return `e178874c0cbc692ff8b5e6a19f6b054ef16947389e7d8d7f609b24a507f67777`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `e178874c0cbc692ff8b5e6a19f6b054ef16947389e7d8d7f609b24a507f67777`, ``);
            }
        }],
        [15, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/heading/heading.twig`, `e178874c0cbc692ff8b5e6a19f6b054ef16947389e7d8d7f609b24a507f67777`, 2);

                this.blocks = new Map([
                    ['content', [this, 'block_content']],
                    ['subheading', [this, 'block_subheading']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/heading/heading.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo((context.has(`content`) ? context.get(`content`) : null));
            }

            block_subheading(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo((context.has(`subheading`) ? context.get(`subheading`) : null));
            }

            getTemplateName() {
                return `e178874c0cbc692ff8b5e6a19f6b054ef16947389e7d8d7f609b24a507f67777`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `e178874c0cbc692ff8b5e6a19f6b054ef16947389e7d8d7f609b24a507f67777`, ``);
            }
        }],
        [16, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/container/container.twig`, `e178874c0cbc692ff8b5e6a19f6b054ef16947389e7d8d7f609b24a507f67777`, 12);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/container/container.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    `);
                this.echo(this.env.getFilter('escape').traceableCallable(17, this.source)(...[this.env, (context.has(`_heading`) ? context.get(`_heading`) : null), `html`, null, true]));
                this.echo(`
  `);
            }

            getTemplateName() {
                return `e178874c0cbc692ff8b5e6a19f6b054ef16947389e7d8d7f609b24a507f67777`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `e178874c0cbc692ff8b5e6a19f6b054ef16947389e7d8d7f609b24a507f67777`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, 'e178874c0cbc692ff8b5e6a19f6b054ef16947389e7d8d7f609b24a507f67777');

let template = env.loadTemplate('e178874c0cbc692ff8b5e6a19f6b054ef16947389e7d8d7f609b24a507f67777');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/components/heading/demo/demo.twig", args: context }
     );
     return rendered;;
};